var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.891,
    height: 128,
    viewBox: "0 0 114.891 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13051",
    "data-name": "Group 13051",
    transform: "translate(-2070.5 -38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lookup",
    transform: "translate(2070.5 38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13052",
    "data-name": "Group 13052",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13051-2",
    "data-name": "Group 13051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6537",
    "data-name": "Path 6537",
    d: "M101.983,0H45.09a4.96,4.96,0,0,0-3.508,1.454L8.008,35.028a4.958,4.958,0,0,0-1.454,3.508v71.852a4.962,4.962,0,0,0,4.961,4.962H48.139a4.962,4.962,0,1,0,0-9.924H16.476V40.591L47.144,9.924H97.02V54.382a4.961,4.961,0,0,0,9.923,0V4.962A4.959,4.959,0,0,0,101.983,0Z",
    transform: "translate(-6.554)",
    fill: "#247395"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6538",
    "data-name": "Path 6538",
    d: "M119.974,119.515l-13.487-13.353a28.158,28.158,0,1,0-7.012,7.02l13.519,13.382a4.96,4.96,0,1,0,6.98-7.049ZM65.211,90.127A18.192,18.192,0,1,1,83.4,108.319,18.214,18.214,0,0,1,65.211,90.127Z",
    transform: "translate(-6.554 0)",
    fill: "#247395"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDetails);
export default __webpack_public_path__ + "static/media/ViewDetails.112d9c04fd80bd06896ca59ea4501ffd.svg";
export { ForwardRef as ReactComponent };